<!--移动端埋点检查下的其他属性-->
<template>
    <div class="mobile-note-other">
        <el-table
            :data="detailData"
            border
            style="width: 100%">
            <el-table-column
                type="index"
                :index="indexMethod">
            </el-table-column>
            <el-table-column
                prop="fieldName"
                label="字段名称">
            </el-table-column>
            <el-table-column
                prop="fieldValue"
                label="字段值">
            </el-table-column>
            <el-table-column
                prop="fieldDes"
                label="字段说明">
            </el-table-column>
            <el-table-column
                v-if="isApp"
                prop="fieldObt"
                label="获取方式">
            </el-table-column>
        </el-table>
    </div>

</template>

<script>
    export default {
        name: "mobile-noteother",
        props: {
            detailData: Array,
            isApp: Boolean
        },
        data() {
            return {}
        },
        methods: {
            indexMethod(index) {
                return index + 1;
            }
        }
    }
</script>

<style scoped>

</style>
